import { useState } from 'react'

import { Trans } from '@lingui/react'

import type {
  InstallmentSpecificContractTerms,
  PlInstallmentsContractTerms,
} from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'

import { InstallmentsContractTermsTable } from './installments-contract-terms-table'
import * as styles from './installments-contract-terms-table.styles'

type Props = {
  contractTerms:
    | Omit<PlInstallmentsContractTerms, '__typename' | 'id'>
    | Omit<InstallmentSpecificContractTerms, '__typename'>
  className?: string
}
export const InstallmentsContractTerms = ({
  contractTerms,
  className,
}: Props) => {
  const [opened, setOpened] = useState(false)

  return (
    <div className={className}>
      <TextButton
        fullWidth
        color="ghost"
        onClick={() => setOpened((prev) => !prev)}
      >
        <Trans id="flow.components.installment.contractTerms.button" />
      </TextButton>
      {opened && (
        <div css={styles.table}>
          <InstallmentsContractTermsTable
            installmentContractTerms={contractTerms}
          />
        </div>
      )}
    </div>
  )
}
